import React from 'react';
import { Redirect } from 'react-router-dom';
// import { Card, Spin } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import { ReactTypeformEmbed } from 'react-typeform-embed';
// import axios from 'axios';
// import { v4 as uuid } from 'uuid';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { useQuery } from '@apollo/react-hooks';
// import { queries } from '../../graphql/graphql';

// import LoggedLayout from '../../components/Layouts/LoggedLayout';
// import GuestLayout from '../../components/Layouts/GuestLayout';
// import NotFound from '../FloorPlans/NotFound';

import actions from '../../store/actions/actions';

// const ViewTypeform = props => {
//   const [loadResult, setLoadResult] = useState(false);
//   const [redirect, setRedirect] = useState(false);
//   const [planId, setPlanId] = useState('');
//   const [error] = useState('');
//   const [notFound, setNotFound] = useState(false);

//   const { match, setConsumerEmail, setRecommendations } = props;
//   const { params } = match;
//   const { id } = params;
//   const { loading, data = {}, refetch } = useQuery(queries.TEMPLATE, { variables: { id } });
//   const { template = {} } = data;

//   useEffect(() => {
//     refetch();
//   }, [data]);

//   if (notFound) {
//     return <NotFound />;
//   }

//   if (!loading && !template.typeformId) return <div>Questions not found.</div>;

//   if (loadResult || loading) {
//     const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
//     return <Spin size="large" indicator={antIcon} tip="Loading..." />;
//   }

//   if (planId && redirect) {
//     // return <Redirect to={`/plan/${planId}`} />;
//     return <Redirect to={`/plan-send-to-email`} />;
//   }

//   if (!id) {
//     return <Card>Error.</Card>;
//   }

//   if (error) {
//     return <Card>{error}</Card>;
//   }

//   if (loading) {
//     return (
//       <Card>
//         <LoadingOutlined />
//       </Card>
//     );
//   }

//   const clientId = uuid();
//   const link = template.link + `?clientid=${clientId}`;

//   const onSubmit = (uid, clientId) => {
//     console.log(clientId);
//     setLoadResult(true);
//     axios({
//       method: 'post',
//       url: '/api/search-plan-by-answers',
//       data: {
//         uid: template.typeformId,
//         clientId,
//         templateId: id
//       }
//     }).then(function(response) {
//       if (response.status === 200) {
//         const { plan, email, plans } = response.data;
//         if (email) setConsumerEmail(email);
//         if (plans && plans.length) setRecommendations(plans);
//         if (!plan) {
//           setNotFound(true);
//         }
//         if (plan && plan._id) {
//           setRedirect(true);
//           setPlanId(plan._id);
//         }
//       } else {
//         console.log(response);
//       }

//       setLoadResult(false);
//     });
//   };

//   // return <Input type="button" value="Get Plan" onClick={() =>   onSubmit("NGgF6HZ1", "ce2af747-4b1a-4b96-9172-21a19b78c1a1")}/>;
//   return <ReactTypeformEmbed url={link} onSubmit={() => onSubmit(template.typeformId, clientId)} />;
// };

const ViewPage = props => {
  return <Redirect to="/" />; // TODO: Remove this component
  // return (
  //   <>
  //     {props.loggedIn ? (
  //       <LoggedLayout>
  //         <ViewTypeform {...props} />
  //       </LoggedLayout>
  //     ) : (
  //       <GuestLayout>
  //         <ViewTypeform {...props} />
  //       </GuestLayout>
  //     )}
  //   </>
  // );
};

const mapStateToProps = state => {
  return {
    loggedIn: state.auth.loggedIn,
    email: state.consumer.email
  };
};

ViewPage.propTypes = {
  loggedIn: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setConsumerEmail: actions.setConsumerEmail,
      setRecommendations: actions.setRecommendations
    },
    dispatch
  );
};

const connectedViewPage = connect(mapStateToProps, mapDispatchToProps)(ViewPage);

export default connectedViewPage;
